import { render, staticRenderFns } from "./EmailButton.vue?vue&type=template&id=2d39e722"
import script from "./EmailButton.vue?vue&type=script&lang=js"
export * from "./EmailButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports